import React, { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Alert
} from "reactstrap";
import classnames from "classnames";
import * as moment from "moment";
import { api } from "../../config";

import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import { fetchComAuth, fetchComAuthJson } from "../../common/api";

const EtapasProcesso = ({ etapas, reservaId, feiraId, cancelada, venda, onUpdate, formaPagamentoId, condicaoPagamentoId, valor, comerciais, comercialId }) => {
  const [modalCancelar, setModalCancelar] = useState(false);
  const [modalFinalizarVenda, setModalFinalizarVenda] = useState(false);
  const [modalEditar, setModalEditar] = useState(false);
  const [modalProrrogar, setModalProrrogar] = useState(false);
  const [modalComercial, setModalComercial] = useState(false);
  const [etapasDisponiveis, setEtapasDisponiveis] = useState([]);
  const [etapaSelecionada, setEtapaSelecionada] = useState("");
  const [observacao, setObservacao] = useState("");
  const [diasProrrogar, setDiasProrrogar] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const authUser = JSON.parse(sessionStorage.getItem("authUser")) || {};
  const userData = authUser.user || authUser;
  const userType = userData.tipo || '';
  const [modalEditarFinanceiro, setModalEditarFinanceiro] = useState(false);
  const [valorTotal, setValorTotal] = useState(valor);
  const [formasPagamento, setFormasPagamento] = useState([]);
  const [condicoesPagamento, setCondicoesPagamento] = useState([]);
  const [formaPagamentoSelecionada, setFormaPagamentoSelecionada] = useState('');
  const [condicaoPagamentoSelecionada, setCondicaoPagamentoSelecionada] = useState('');
  const [observacaoFinanceira, setObservacaoFinanceira] = useState('');
  const [loadingFinanceiro, setLoadingFinanceiro] = useState(false);
  const [modalArquivos, setModalArquivos] = useState(false);
  const [files, setFiles] = useState([]);
  const [observacaoArquivos, setObservacaoArquivos] = useState("");
  const [loadingArquivos, setLoadingArquivos] = useState(false);
  const [arquivosEnviados, setArquivosEnviados] = useState([]);
  const [emailRenovacao, setEmailRenovacao] = useState("");
  //const [comerciaisFeira, setComerciaisFeira] = useState([]);
  const [comercialSelecionado, setComercialSelecionado] = useState('');

  const etapasOrdenadas = [...etapas].sort((a, b) => 
    new Date(a.created_at) - new Date(b.created_at)
  );

  const buscarDadosPagamento = async () => {
    try {
      // Busca formas de pagamento
      const responseFormas = await fetchComAuth(`${api.API_URL}/forma-pagamento`, {
        method: 'GET'
      });
      const dataFormas = await responseFormas.json();
      setFormasPagamento(dataFormas.data || []);

      // Busca condições de pagamento
      const responseCondicoes = await fetchComAuth(`${api.API_URL}/condicao-pagamento`, {
        method: 'GET'
      });
      const dataCondicoes = await responseCondicoes.json();
      setCondicoesPagamento(dataCondicoes.data || []);

    } catch (error) {
      console.error("Erro ao buscar dados de pagamento:", error);
      toast.error("Erro ao carregar formas de pagamento");
    }
  };
    // const userFeirasIds = userData.feiras?.map(item => item.feira_id) || [];

  // Função para formatar a data
  const formatarData = (date) => {
    return moment(new Date(date)).format("DD/MM/YYYY [às] HH:mm");
  };

  const handleEtapaChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setEtapaSelecionada(selectedId);
    if (selectedId !== 7) {
      setEmailRenovacao(""); // limpa caso mude para outro
    }
  };

  const handleEnviarArquivos = async () => {
    try {
      setLoadingArquivos(true);
      
      const formData = new FormData();
      const filesArray = files instanceof FileList ? 
      Array.from(files) : 
      (Array.isArray(files) ? files : []);

    // Adiciona cada arquivo ao FormData
    filesArray.forEach(file => {
      formData.append('arquivos', file); // Sem os colchetes []
    });
  
      formData.append('reserva_id', reservaId);
      formData.append('observacao', observacaoArquivos);
      formData.append('feira_id', feiraId);

      const response = await fetchComAuthJson(`${api.API_URL}/reserva/arquivos/${reservaId}`, {
        method: 'POST',
        body: formData
      });


      if (response.status) {
        toast.success("Arquivos enviados com sucesso!");
        setModalArquivos(false);
        setFiles([]);
        setObservacaoArquivos("");
        if (onUpdate) onUpdate();
      } else {
        throw new Error(response.data.message || "Falha ao enviar arquivos");
      }
    } catch (err) {
      toast.error(err.message || "Erro ao enviar arquivos");
    } finally {
      setLoadingArquivos(false);
    }
  };

  const salvarEdicaoFinanceira = async () => {
    setLoadingFinanceiro(true);
    try {

      const response = await fetchComAuthJson(`${api.API_URL}/reserva/financeiro`, {
        method: 'POST',
        body: JSON.stringify({
          reserva_id: reservaId,
          feira_id: feiraId,
          forma_pagamento_id: formaPagamentoSelecionada,
          condicao_pagamento_id: condicaoPagamentoSelecionada,
          valor_total: valorTotal,
          observacao: observacao
        })
      });

      if (response.ok) {
        setSuccess('Dados financeiros atualizados com sucesso!');
        setModalEditarFinanceiro(false);
        setObservacao('');
        setFormaPagamentoSelecionada(null);
        setCondicaoPagamentoSelecionada(null);
        setValorTotal(0);
        setLoadingFinanceiro(false);
        if (onUpdate) onUpdate();
      } else {
        toast.error("Erro ao atualizar dados financeiros!");
         setLoadingFinanceiro(false);
      }
    } catch (err) {
      console.log(err);
       setLoadingFinanceiro(false);
      toast.error("Falha na conexão com o servidor");
    }
  };

  // Mapeamento dos ícones para cada tipo de etapa
  const getEtapaIcon = (etapaReserva) => {
    switch (etapaReserva?.nome?.toLowerCase()) {
      case "solicitação recebida":
        return "ri-shopping-bag-line";
      case "em análise":
        return "ri-file-search-line";
      case "aprovada":
        return "ri-checkbox-circle-line";
      case "em preparação":
        return "ri-truck-line";
      case "em transporte":
        return "ri-truck-line";
      case "entregue":
        return "ri-home-4-line";
      case "concluído":
        return "ri-check-double-line";
      default:
        return "ri-information-line";
    }
  };

  // Mapeamento das cores para cada tipo de etapa
  const getEtapaColor = (etapaReserva) => {
    switch (etapaReserva?.nome?.toLowerCase()) {
      case "solicitação recebida":
        return "primary";
      case "em análise":
        return "info";
      case "aprovada":
        return "success";
      case "em preparação":
        return "warning";
      case "em transporte":
        return "warning";
      case "entregue":
        return "danger";
      case "concluído":
        return "success";
      default:
        return "secondary";
    }
  };

  const abrirModalEditarFinanceiro = async () => {
    setLoadingFinanceiro(true);
    try {
      await buscarDadosPagamento();
      
      // Preenche os valores atuais
      setFormaPagamentoSelecionada(formaPagamentoId);
      setCondicaoPagamentoSelecionada(condicaoPagamentoId);
      setValorTotal(valorTotal);
      setObservacaoFinanceira(observacao);
      
      setModalEditarFinanceiro(true);
    } catch (error) {
      toast.error("Erro ao preparar edição financeira");
    } finally {
      setLoadingFinanceiro(false);
    }
  }; 

  const abrirModalAlterarComercial = async () => {
    setLoading(true);
    try {
      setComercialSelecionado(comercialId);
      setModalComercial(true);
    } catch (error) {
      toast.error("Erro ao preparar edição financeira");
    } finally {
      setLoading(false);
    }
  }; 
  // Abrir modal de edição e carregar etapas disponíveis
  const abrirModalEditar = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetchComAuth(`${api.API_URL}/etapa-reserva`, {
        method: 'GET'
      });
      
      const data = await response.json();
      setEtapasDisponiveis(data.data || []);
      setModalEditar(true);
      
    } catch (err) {
      setError(err.message || 'Falha ao carregar etapas disponíveis');
    } finally {
      setLoading(false);
    }
  };

  // Enviar solicitação de cancelamento
  const handleCancelar = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetchComAuthJson(`${api.API_URL}/reserva/cancelar`, {
        method: 'POST',
        body: JSON.stringify({
          observacao: observacao,
          reserva_id: reservaId,
          feira_id: feiraId
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setSuccess('Reserva cancelada com sucesso!');
        setModalCancelar(false);
        setObservacao('');
        if (onUpdate) onUpdate(); // Atualizar dados da reserva
      } else {
        throw new Error(data.message || 'Falha ao cancelar reserva');
      }
      
    } catch (err) {
      setError(err.message || 'Erro ao processar cancelamento');
    } finally {
      setLoading(false);
    }
  };

  // Enviar solicitação de cancelamento
  const handleFinalizarVenda = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetchComAuthJson(`${api.API_URL}/reserva/finalizar`, {
        method: 'POST',
        body: JSON.stringify({
          observacao: observacao,
          reserva_id: reservaId,
          feira_id: feiraId
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setSuccess('Reserva atualizada com sucesso!');
        setModalFinalizarVenda(false);
        setObservacao('');
        if (onUpdate) onUpdate(); 
      } else {
        throw new Error(data.message || 'Falha ao cancelar reserva');
      }
      
    } catch (err) {
      setError(err.message || 'Erro ao processar cancelamento');
    } finally {
      setLoading(false);
    }
  };

  // Enviar solicitação de edição de etapa
  const handleEditar = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetchComAuthJson(`${api.API_URL}/reserva/etapa`, {
        method: 'POST',
        body: JSON.stringify({
          etapa_reserva_id: etapaSelecionada,
          observacao: observacao,
          reserva_id: reservaId,
          feira_id: feiraId,
          email_renovacao: etapaSelecionada === 7 ? emailRenovacao : null
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        setSuccess('Etapa atualizada com sucesso!');
        setModalEditar(false);
        setEtapaSelecionada('');
        setObservacao('');
        if (onUpdate) onUpdate(); // Atualizar dados da reserva
      } else {
        throw new Error(data.message || 'Falha ao atualizar etapa');
      }
      
    } catch (err) {
      setError(err.message || 'Erro ao processar atualização');
    } finally {
      setLoading(false);
    }
  };

  // Enviar solicitação de prorrogação
  const handleProrrogar = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await fetchComAuthJson(`${api.API_URL}/reserva/prorrogar`, {
        method: 'POST',
        body: JSON.stringify({
          observacao: observacao,
          reserva_id: reservaId,
          feira_id: feiraId,
          dias:diasProrrogar
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast.success("Prorrogação solicitada com sucesso!");
        setModalProrrogar(false);
        setObservacao('');
        if (onUpdate) onUpdate(); // Atualizar dados da reserva
      } else {
        throw new Error(data.message || 'Falha ao solicitar prorrogação');
      }
      
    } catch (err) {
      setError(err.message || 'Erro ao processar prorrogação');
    } finally {
      setLoading(false);
    }
  };

   // Enviar solicitação de prorrogação
  const handleAlterarComercial = async () => {
    try {
      setLoading(true);
      setError(null);
       
      const response = await fetchComAuthJson(`${api.API_URL}/comercialReserva`, {
        method: 'PUT',
        body: JSON.stringify({
          comercial_id: comercialSelecionado,
          reserva_id: reservaId,
          usuario_id: userData.id,
          feira_id: feiraId
        })
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast.success('Comercial alterado com sucesso!');
        setModalComercial(false);
        setObservacao('');
        if (onUpdate) onUpdate(); // Atualizar dados da reserva
      } else {
        throw new Error(data.message || 'Falha ao solicitar alteração');
      }
      
    } catch (err) {
      setError(err.message || 'Falha ao solicitar alteração');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Card>
        <ToastContainer closeButton={false} />
        <CardHeader>
            <div className="d-flex flex-wrap gap-2">
            { ((cancelada && ['COMERCIAL'].includes(userType))|| venda && ['COMERCIAL'].includes(userType)) ? <div></div> : 
              <>
                <Button onClick={() => setModalArquivos(true)} color='primary' className="shadow-none btn-soft-primary btn-sm mt-2 mt-sm-0"> <i className="ri-attachment-line align-middle me-1"></i> Enviar Arquivos </Button>
                <Button onClick={() => abrirModalEditarFinanceiro(true)} className="shadow-none btn-soft-secondary btn-sm mt-2 mt-sm-0"> <i className="ri-edit-2-line me-1"></i> Editar Dados Financeiros </Button>
                <Button onClick={abrirModalEditar} className="shadow-none btn-soft-success btn-sm mt-2 mt-sm-0"> <i className="ri-map-pin-line align-middle me-1"></i>{" "}Atualizar Reserva </Button>
                <Button onClick={() => setModalProrrogar(true)} className="shadow-none btn-soft-info btn-sm mt-2 mt-sm-0"> <i className="ri-time-line align-middle me-1"></i>{" "} Prorrogar Reserva </Button>
                <Button onClick={() => setModalCancelar(true)} className="shadow-none btn-soft-danger btn-sm mt-2 mt-sm-0"> <i className="mdi mdi-archive-remove-outline align-middle me-1"></i>{" "} Cancelar Reserva </Button>
              </>
            }
            {(['JOTAPIX', 'EVOMAP', 'ORGANIZACAO'].includes(userType)) && (
              <>
                <Button onClick={() => abrirModalAlterarComercial(true)} className="shadow-none btn-soft-warning btn-sm mt-2 mt-sm-0"> <i className="ri-shopping-bag-line align-middle me-1"></i>{" "}Alterar Comercial </Button>
              </>
            )}

            {!venda && (
              <Button onClick={() => setModalFinalizarVenda(true)} className="btn-success mt-2 mt-sm-0"> <i class="ri-money-dollar-box-fill me-2" style={{fontSize:"large"}}></i>{" "}Finalizar Venda </Button>
            )}
            
          </div>
        </CardHeader>
        <CardBody>
        
          {error && <Alert color="danger">{error}</Alert>}
          {success && <Alert color="success">{success}</Alert>}
          
        <div className="d-sm-flex align-items-center">
            <h5 className="card-title flex-grow-1 mb-0">Acompanhe o processo :</h5>
           
          </div>
          <div className="profile-timeline">
            <div className="accordion accordion-flush" id="accordionFlushExample">
              {etapasOrdenadas?.map((etapa, index) => {
                const isLast = index === etapasOrdenadas.length - 1;
                const icon = getEtapaIcon(etapa.etapa_reserva);
                const color = getEtapaColor(etapa.etapa_reserva);
                
                return (
                  <div className="accordion-item border-0" key={`etapa-${etapa.id}`}>
                    <div className="accordion-header" id={`heading-${etapa.id}`}>
                      <button
                        type="button"
                        className={classnames(
                          "accordion-button",
                          "p-2",
                          "shadow-none",
                          { collapsed: !isLast }
                        )}
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse-${etapa.id}`}
                        aria-expanded={isLast ? "true" : "false"}
                        aria-controls={`collapse-${etapa.id}`}
                      >
                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0 avatar-xs">
                            <div className={`avatar-title bg-${color} rounded-circle`}>
                              <i className={icon}></i>
                            </div>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <h6 className="fs-15 mb-0 fw-semibold">
                              {etapa.etapa_reserva?.nome || "Etapa do Processo"} -{" "}
                              <span className="fw-normal">
                                {formatarData(etapa.created_at)}
                              </span>
                            </h6>
                            <h6 className="mb-1">
                              Obs: {etapa.observacao || "Sem observações adicionais"}
                            </h6>
                            <p className="text-muted mb-0">
                              {etapa.usuario && (
                                <span> Atualizado por {etapa.usuario.name || "usuário não identificado"}</span>
                              )}
                            </p>
                          </div>
                        </div>
                      </button>
                    </div>
                    <div
                      id={`collapse-${etapa.id}`}
                      className={classnames(
                        "accordion-collapse",
                        "collapse",
                        { show: isLast }
                      )}
                      aria-labelledby={`heading-${etapa.id}`}
                      data-bs-parent="#accordionFlushExample"
                    >
                      {/* <div className="accordion-body ms-2 ps-5 pt-0">
                        <h6 className="mb-1">
                          {etapa.observacao || "Sem observações adicionais"}
                        </h6>
                        <p className="text-muted mb-0">
                          Atualizado em: {formatarData(etapa.updated_at)}
                          {etapa.usuario && (
                            <span> por {etapa.usuario.name || "usuário não identificado"}</span>
                          )}
                        </p>
                      </div> */}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </CardBody>
      </Card>

      <Modal isOpen={modalArquivos} toggle={() => setModalArquivos(!modalArquivos)} size="lg">
        <ModalHeader toggle={() => setModalArquivos(!modalArquivos)}>
          <i className="ri-file-upload-line me-2"></i>
          Enviar Arquivos
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label>Arquivos</Label>
              <FileUploader
              label="Arraste e solte arquivos aqui ou clique para selecionar"
            hoverTitle="Solte aqui!"
                multiple={true}
                handleChange={(files) => setFiles(files)}
                name="arquivos"
                types={["JPG", "PNG", "PDF", "DOC", "DOCX", "XLS", "XLSX"]}
              >
                
                </FileUploader>
              <div className="mt-2">
                {files.length > 0 && (
                  <div>
                    <h6>Arquivos selecionados:</h6>
                    <ul>
                      {Array.from(files).map((file, index) => (
                        <li key={index}>{file.name}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </FormGroup>
            
            <FormGroup>
              <Label>Observação</Label>
              <Input
                type="textarea"
                value={observacaoArquivos}
                onChange={(e) => setObservacaoArquivos(e.target.value)}
                placeholder="Informe uma observação sobre os arquivos (opcional)"
                rows="3"
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalArquivos(false)} disabled={loadingArquivos}>
            Cancelar
          </Button>
          <Button 
            color="primary" 
            onClick={handleEnviarArquivos} 
            disabled={loadingArquivos || files.length === 0}
          >
            {loadingArquivos ? 'Enviando...' : 'Enviar Arquivos'}
          </Button>
        </ModalFooter>
      </Modal>

        
      <Modal isOpen={modalEditarFinanceiro} toggle={() => setModalEditarFinanceiro(false)} size="lg">
      <ModalHeader toggle={() => setModalEditarFinanceiro(false)}>
        <i className="ri-money-dollar-circle-line me-2"></i>
        Editar Dados Financeiros
      </ModalHeader>
      <ModalBody>
        {loadingFinanceiro ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Carregando...</span>
            </div>
          </div>
        ) : (
          <Form>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Forma de Pagamento</Label>
                  <Input
                    type="select"
                    value={formaPagamentoSelecionada}
                    onChange={(e) => setFormaPagamentoSelecionada(e.target.value)}
                  >
                    <option value="">Selecione...</option>
                    {formasPagamento.map((forma) => (
                      <option key={forma.id} value={forma.id}>
                        {forma.nome}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>Condição de Pagamento</Label>
                  <Input
                    type="select"
                    value={condicaoPagamentoSelecionada}
                    onChange={(e) => setCondicaoPagamentoSelecionada(e.target.value)}
                  >
                    <option value="">Selecione...</option>
                    {condicoesPagamento.map((condicao) => (
                      <option key={condicao.id} value={condicao.id}>
                        {condicao.nome}
                      </option>
                    ))}
                  </Input>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>Valor Total (R$)</Label>
                  <Input
                    type="number"
                    value={valorTotal}
                    onChange={(e) => setValorTotal(e.target.value)}
                    min="0"
                    step="0.01"
                  />
                </FormGroup>
              </Col>
            </Row>

            <FormGroup>
              <Label>Observação</Label>
              <Input
                type="textarea"
                value={observacaoFinanceira}
                onChange={(e) => setObservacaoFinanceira(e.target.value)}
                rows="3"
              />
            </FormGroup>
          </Form>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => setModalEditarFinanceiro(false)}>
          Cancelar
        </Button>
        <Button color="primary" onClick={salvarEdicaoFinanceira} disabled={loadingFinanceiro}>
          {loadingFinanceiro ? 'Salvando...' : 'Salvar Alterações'}
        </Button>
      </ModalFooter>
      </Modal>

      <Modal isOpen={modalCancelar} toggle={() => setModalCancelar(!modalCancelar)} centered={true}>
        <ModalHeader toggle={() => setModalCancelar(!modalCancelar)}>Cancelar Reserva</ModalHeader>
        <ModalBody className="py-3 px-5">
          <Form>
            <FormGroup>
              <Label for="observacaoCancelar">Motivo do Cancelamento</Label>
              <Input
                type="textarea"
                id="observacaoCancelar"
                value={observacao}
                onChange={(e) => setObservacao(e.target.value)}
                placeholder="Informe o motivo do cancelamento"
                required
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalCancelar(false)} disabled={loading}>
            Voltar
          </Button>
          <Button color="danger" onClick={handleCancelar} disabled={loading}>
            {loading ? 'Processando...' : 'Confirmar Cancelamento'}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalFinalizarVenda} toggle={() => setModalFinalizarVenda(!modalFinalizarVenda)} centered={true}>
        <ModalHeader toggle={() => setModalFinalizarVenda(!modalFinalizarVenda)}>Deseja realmente Finalizar Venda? </ModalHeader>
        <ModalBody className="py-3 px-5">
          <Form>
            <FormGroup>
              <Label for="observacaoFinalizar">Observação</Label>
              <Input
                type="textarea"
                id="observacaoFinalizar"
                value={observacao}
                onChange={(e) => setObservacao(e.target.value)}
                placeholder="Informe a observação"
                required
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalFinalizarVenda(false)} disabled={loading}>
            Voltar
          </Button>
          <Button color="success" onClick={handleFinalizarVenda} disabled={loading}>
            {loading ? 'Processando...' : 'Confirmar Venda'}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Editar Reserva */}
      <Modal isOpen={modalEditar} toggle={() => setModalEditar(!modalEditar)}>
        <ModalHeader toggle={() => setModalEditar(!modalEditar)}>Alterar Etapa da Reserva</ModalHeader>
        <ModalBody className="py-3 px-5">
          <Form>
            <FormGroup>
              <Label for="etapaReserva">Nova Etapa</Label>
              <Input
                type="select"
                id="etapaReserva"
                value={etapaSelecionada}
                onChange={handleEtapaChange}
                disabled={loading || etapasDisponiveis.length === 0}
              >
                <option value="">Selecione uma etapa</option>
                {etapasDisponiveis.map((etapa) => (
                  <option key={etapa.id} value={etapa.id}>
                    {etapa.nome}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup>
              <Label for="observacaoEditar">Observação</Label>
              <Input
                type="textarea"
                id="observacaoEditar"
                value={observacao}
                onChange={(e) => setObservacao(e.target.value)}
                placeholder="Informe uma observação (opcional)"
              />
            </FormGroup>
            {etapaSelecionada === 7 && (
              <FormGroup>
                <Label for="emailRenovacao">E-mail de Renovação</Label>
                <Input
                  type="email"
                  id="emailRenovacao"
                  value={emailRenovacao}
                  onChange={(e) => setEmailRenovacao(e.target.value)}
                  placeholder="Digite o e-mail para renovação"
                  required
                />
              </FormGroup>
            )}

          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalEditar(false)} disabled={loading}>
            Voltar
          </Button>
          <Button color="primary" onClick={handleEditar} disabled={loading || !etapaSelecionada}>
            {loading ? 'Processando...' : 'Salvar Alteração'}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Prorrogar Reserva */}
      <Modal isOpen={modalProrrogar} toggle={() => setModalProrrogar(!modalProrrogar)}>
        <ModalHeader toggle={() => setModalProrrogar(!modalProrrogar)}>Solicitar Prorrogação</ModalHeader>
        <ModalBody className="py-3 px-5">
          <Form>
            <FormGroup>
              <Label for="observacaoProrrogar">Motivo da Prorrogação</Label>
              <Input
                type="textarea"
                id="observacaoProrrogar"
                value={observacao}
                onChange={(e) => setObservacao(e.target.value)}
                placeholder="Informe o motivo da prorrogação"
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="diasProrrogar">Dias de Prorrogação</Label>
              <Input
                type="textarea"
                id="diasProrrogar"
                value={diasProrrogar}
                onChange={(e) => setDiasProrrogar(e.target.value)}
                placeholder="Informe a quantidade de dias para prorrogação"
                required
              />
            </FormGroup>
            <p className="text-muted">
              O prazo de prorrogação padrão será aplicado automaticamente caso nao seja informada a quantidade de dias.
            </p>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalProrrogar(false)} disabled={loading}>
            Voltar
          </Button>
          <Button color="warning" onClick={handleProrrogar} disabled={loading}>
            {loading ? 'Processando...' : 'Solicitar Prorrogação'}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Alterar Comercial Reserva */}
      <Modal isOpen={modalComercial} toggle={() => setModalComercial(!modalComercial)}>
        <ModalHeader toggle={() => setModalComercial(!modalComercial)}>Solicitar Alteração Comercial</ModalHeader>
        <ModalBody className="py-3 px-5">
          <Form>
            <FormGroup>
              <Label for="comercial">Comercial</Label>
              <Input
                type="select"
                value={comercialSelecionado}
                onChange={(e) => setComercialSelecionado(e.target.value)}
              >
        
                <option value="">Selecione...</option>
                {comerciais.map((com) => (
                  <option key={com.id} value={com.id}>
                    {com.nome}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setModalComercial(false)} disabled={loading}>
            Voltar
          </Button>
          <Button color="warning" onClick={handleAlterarComercial} disabled={loading}>
            {loading ? 'Processando...' : 'Solicitar Alteração'}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default EtapasProcesso;